import { render, staticRenderFns } from "./StatisticsComponent.vue?vue&type=template&id=7f29b2b6&lang=pug&"
import script from "./StatisticsComponent.vue?vue&type=script&lang=js&"
export * from "./StatisticsComponent.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsComponent.vue?vue&type=style&index=0&id=7f29b2b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports